import React, { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useParams, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { StorageKeys } from '../constants';
import ErrorPage from '../pages/ErrorPage';

interface GuestGuardProps {
  children: ReactNode;
}

const GuestGuard = (props: GuestGuardProps) => {
  const { children } = props;
  const params = useParams();
  const location = useLocation();
  const { user } = useAuth();

  if (!localStorage.getItem('access-token')) {
    params?.viewId && localStorage.setItem(StorageKeys.redirect, location?.pathname);
    return <Navigate to="/" />;
  }

  return (
    <>
      {
        !user ? (
          <ErrorPage />
        ) : (
          children
        )
      }
    </>
  );
};

export default GuestGuard;
